import {
    ChangeDetectorRef,
    Component,
    ComponentRef,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, MenuItem, MessageService, TreeNode} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {
    Column,
    ConfiguratorDataViewService,
    ConfiguratorTableService,
    DataViewDto,
    FieldTable,
    FieldTableDto,
    Table,
    TableJointure
} from '@tj/tj-dmp-lib-api';

import {BuildComponentService} from '../../../services/build-component.service';


@Component({
    selector: 'dmp-view-item-editor',
    templateUrl: './view-item-editor.component.html',
    styleUrls: ['./view-item-editor.component.scss'],
    providers: [
        BuildComponentService,
        MessageService
    ],
    standalone: false
})
export class ViewItemEditorComponent implements OnInit, OnDestroy {
    breadcrumb: MenuItem[] = [
        {label: this.translate.instant('menu.data-center.label')},
        {label: this.translate.instant('menu.data-center.views'), routerLink: '/h/settings/view-editor'},
        {label: this.translate.instant('tagsEvent.detailsMenuLabel')},
    ];
    codeDatastore: string;
    private id: string;
    public data: DataViewDto;
    public dataOrigin: DataViewDto;
    public table: TreeNode[];
    public editTable = false;
    // Liste des colonnes du tableau
    public fieldDisplayCol: FieldTableDto[] = [];
    public selectedFieldDisplayCol: FieldTableDto[] = [];
    // Liste des champs pour la création d'un enregistrement
    public fieldCreationCol: FieldTableDto[] = [];
    public selectedFieldCreationCol: FieldTableDto[] = [];

    private dynCmpt: ComponentRef<any>;

    editorOptions = {
        theme: 'vs',
        lineNumbers: 'on',
        language: 'html',
        readOnly: false,
    };

    editingField: 'name' | 'description' | null = null;
    editableData = { name: '', description: '' };
    editableLabels: { [lang: string]: string } = {};
    readonly labelLangs = ['FR', 'EN', 'IT'];

    code: string = null;

    showTechnicalView: boolean = false;

    @ViewChild('container', { read: ViewContainerRef, static: false })
    container: ViewContainerRef;
    activeIndex = 0;

    constructor(private router: Router,
                private confirmationService: ConfirmationService,
                private translate: TranslateService,
                private messageService: MessageService,
                protected tableResourceService: ConfiguratorTableService,
                private configuratorDataViewService: ConfiguratorDataViewService,
                private route: ActivatedRoute,
                private buildComponentService: BuildComponentService,
                private cdref: ChangeDetectorRef
    ) {
    }

    private initArray() {
        // Liste des colonnes du tableau
        this.fieldDisplayCol = [];
        this.selectedFieldDisplayCol = [];
        // Liste des champs pour la création d'un enregistrement
        this.fieldCreationCol = [];
        this.selectedFieldCreationCol = [];
    }

    ngOnInit(): void {
        this.codeDatastore = this.route.snapshot.paramMap.get('datastore');
        this.id = this.route.snapshot.paramMap.get('id');
        this.loadData();

    }

    private loadData(): void {
        this.initArray();
        this.configuratorDataViewService
            .getDataViewUsingGET(this.codeDatastore, null, this.id, false)
            .subscribe(res => {
                this.data = res;
                const item: TreeNode = {
                    label: `${res.table.tableName}`,
                    data: res.table,
                    type: 'root',
                    children: []
                };
                this.appendNode(res.table, item);
                this.table = [item];



                this.fieldDisplayCol = [];
                this.fieldCreationCol = [];
                const codeTables = res.selectColumns.map(c => c.tableName);
                this.tableResourceService
                    .getTablesUsingGET(this.codeDatastore, codeTables)
                    .subscribe(tables => {
                        this.loadField(tables, res.defaultDisplayFields, this.fieldDisplayCol, this.selectedFieldDisplayCol);
                        this.loadField(tables, res.defaultFieldCreation, this.fieldCreationCol, this.selectedFieldCreationCol);

                        tables.forEach(t =>
                            t.fields
                                .forEach(f => {
                                    const col = {
                                        table: t.label.length > 0 ? t.label : t.code,
                                        code: `${t.code}.${f.code}`,
                                        label: f.label.length > 0 ? f.label : f.code,
                                        description: f.description
                                    };
                                    this.loadFieldStep2(col, t, f, res.defaultDisplayFields, this.fieldDisplayCol);
                                    this.loadFieldStep2(col, t, f, res.defaultFieldCreation, this.fieldCreationCol,
                                        (t, f) => {
                                            return f.categoryField !== 'TECHNICAL';
                                        });
                                })
                        );
                    });
                    this.editableData = {
                        name: this.data.name,
                        description: this.data.description
                    };
            });
    }

    private loadFieldStep2(col: any, t: Table, f: FieldTable,
                           defaulFieldCol: Array<Column>, fieldCol: FieldTableDto[],
                           doFilter?: (t: Table, f: FieldTable) => boolean) {
        if (f.categoryField !== 'TECHNICAL' &&
            (defaulFieldCol == null ||
            defaulFieldCol.every(df => (df.tableName + df.propertyName) !== (t.code + f.code)))
        && (doFilter == null || doFilter(t, f))) {
            fieldCol.push(col);
        }
    }

    private loadField(tables: Table[], defaulFieldCol: Array<Column>, fieldCol: FieldTableDto[], selectedFieldCol: FieldTableDto[]) {
        defaulFieldCol?.forEach(dField => {
            const t = tables.find(table => table.code === dField.tableName);
            const f = t?.fields.find(field => field.code === dField.propertyName);
            if (f && f.categoryField !== 'TECHNICAL') {
                const col: FieldTableDto = {
                    table: t.label.length > 0 ? t.label : t.code,
                    code: `${t.code}.${f.code}`,
                    label: f.label.length > 0 ? f.label : f.code,
                    description: f.description
                };
                fieldCol.push(col);
                selectedFieldCol.push(col);
            }
        });
    }


    private appendNode(table: TableJointure,  node: TreeNode) {
        table.join.forEach(t => {
            // @ts-ignore
            t.tableNameOrg = node.label;
            const nodeSub = {
                label: `${t.tableName}`,
                type: 'table',
                data: t,
                children: []
            };
            this.appendNode(t, nodeSub);
            node.children.push(nodeSub);
        });
    }

    public save() {
        this.data.defaultDisplayFields = [];
        this.mappingSave(this.selectedFieldDisplayCol, this.data.defaultDisplayFields);
        this.data.defaultFieldCreation = [];
        this.mappingSave(this.selectedFieldCreationCol, this.data.defaultFieldCreation);

        this.configuratorDataViewService.updateDataViewUsingPUT(this.codeDatastore, this.data).subscribe(res => {
            this.loadData();
            this.messageService.add({severity: 'success', summary: this.translate.instant('datastore.successSummary'), detail: this.translate.instant('viewEditor.item.saveSuccessDetail')});
        });
    }

    private mappingSave(src: Array<FieldTableDto>, dest: Array<Column>) {
        src.forEach((fd, index) => {
            const [tableName, propertyName] = fd.code.split('.');
            dest.push({
                tableName : tableName,
                propertyName: propertyName,
                distinct: false,
                schema: fd.schema,
                fieldJoin: null,
                leftOuterJoin: null
            });
        });
    }

    public onRowReorder(tabPanel: string): void {
        switch(tabPanel) {
            case 'displayCol':
                const newOrderMapDisplayCol = new Map(this.fieldDisplayCol.map((col, index) => [col.code, index]));
                this.selectedFieldDisplayCol = this.selectedFieldDisplayCol.slice().sort((a, b) => newOrderMapDisplayCol.get(a.code) - newOrderMapDisplayCol.get(b.code));
                break;
            case 'creationCol':
                const newOrderMapCreationCol = new Map(this.fieldCreationCol.map((col, index) => [col.code, index]));
                this.selectedFieldCreationCol = this.selectedFieldCreationCol.slice().sort((a, b) => newOrderMapCreationCol.get(a.code) - newOrderMapCreationCol.get(b.code));
        }
    }

    doChangePanel($event: any) {
        switch ($event.index) {
            case 2:
                // this.refreshCmpt(true);
                break;
            default:
                break;
        }
    }

    private refreshCmpt(refreshHtml: boolean) {
        const context = { name: 'Angular' };

        if (this.dynCmpt != null && refreshHtml) {
            this.dynCmpt.destroy();
            this.container.clear();
            this.dynCmpt = null;
        }

        if (this.dynCmpt == null) {
            const template = this.data.customPageHtml || '';
            this.buildComponentService.loadComponent(this.container, template, context).then(cmpt => this.dynCmpt = cmpt);
        } else {
            // context = { name: 'Angular+2' };
            this.buildComponentService.updateComponent(this.dynCmpt, context);
        }
    }

    ngOnDestroy(): void {
        this.buildComponentService.destroy();
    }

    doValueChangeEditor($event: any) {
        console.log('doValueChangeEditor');
        this.refreshCmpt(true);
    }

    doInitEditor($event: any) {
        console.log('doInitEditor');
    }

    startEdit(field: 'name' | 'description') {
        this.editingField = field;
        this.editableData[field] = this.data[field];
        if (field === 'name') {
            this.editableLabels = { ...(this.data.labels ?? {}) };
            this.editableLabels.FR = this.editableLabels.FR || this.data.name;
        }
    }
      
    saveEdit(field: 'name' | 'description') {
        if (field === 'name') {
            this.editableData.name = this.editableLabels.FR;
        }
        let error: boolean = false;
        if (!this.editableData[field] || this.editableData[field].trim() === '') {
            const fieldLabel = this.translate.instant(field === 'name' ? 'table.label' : 'common.Description');
            this.messageService.add({ severity: 'error', summary: this.translate.instant('datastore.errorSummary'), detail: this.translate.instant('viewEditor.item.fieldRequiredError', {field: fieldLabel}) });
            error = true;
        } else if (field === 'name' && this.labelLangs.some(lang => (this.editableLabels[lang] ?? '').length > 30)) {
            this.messageService.add({ severity: 'error', summary: this.translate.instant('datastore.errorSummary'), detail: this.translate.instant('viewEditor.item.labelMaxLengthError') });
            error = true;
        } else if (field === 'description' && this.editableData[field].length > 1000) {
            this.messageService.add({ severity: 'error', summary: this.translate.instant('datastore.errorSummary'), detail: this.translate.instant('viewEditor.item.descriptionMaxLengthError') });
            error = true;
        }

        if (!error) {
            this.data[field] = this.editableData[field];
            if (field === 'name') {
                const labels: { [lang: string]: string } = {};
                this.labelLangs
                    .filter(lang => this.editableLabels[lang]?.trim())
                    .forEach(lang => labels[lang] = this.editableLabels[lang].trim());
                this.data.labels = labels;
            }
            this.editingField = null;
            this.configuratorDataViewService.updateDataViewUsingPUT(this.codeDatastore, this.data).subscribe(res => {
                this.loadData();
            });
        }
    }

    cancelEdit() {
        this.editingField = null;
    }

    public toggleTechnicalView(): void {
        this.showTechnicalView = !this.showTechnicalView;
        if (this.showTechnicalView && this.table && this.table.length > 0) {
            setTimeout(() => {
                this.expandAllNodes();
            }, 0);
        }
    }

    private expandAllNodes(): void {
        if (this.table) {
            this.table.forEach(node => {
                this.expandRecursive(node, true);
            });
        }
    }

    private expandRecursive(node:TreeNode, isExpand:boolean): void {
        node.expanded = isExpand;
        if(node.children && node.children.length > 0){
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
}
